import { z } from 'zod';

/** Rôles auxquels un menu de la barre latérale peut être montré. */
export const MENU_ROLES = ['ADMIN', 'DENDROMAP', 'MANAGER', 'AGENT', 'USER', 'VISITEUR'] as const;
export type MenuRole = (typeof MENU_ROLES)[number];

/**
 * Visibilité des menus par rôle, réglée dans l'espace /superadmin.
 * Clé = lien du menu (ex. « /admin/smart-map », ou « /travaux » pour un groupe) ; valeur = rôles qui le voient.
 * Un menu absent de la configuration garde ses rôles par défaut (définis dans la barre latérale).
 */
export const MenuConfigSchema = z.record(
  z.string().min(1).max(255).startsWith('/', 'Clé de menu invalide'),
  z.array(z.enum(MENU_ROLES)).max(MENU_ROLES.length),
);
export type MenuConfig = z.infer<typeof MenuConfigSchema>;

export const MenuConfigUpdateSchema = z.object({ menu_config: MenuConfigSchema });
export type MenuConfigUpdateInput = z.infer<typeof MenuConfigUpdateSchema>;
